import * as React from 'react';

import { SCREEN_BREAKPOINT_NAMES } from '@/components/modular-grid/constants';
import { useWindowBreakpoint } from '@/hooks/useWindowBreakpoint';
import { CallbackMode, DeviceType } from '@/logic/main/types';
import { isIframeWrapperEnabled } from '@/logic/main/utils';
import { GameLaunchStrategies } from '@/types/gameTypes';

export const DEFAULT_GAME_STRATEGY = 'default';

export const LaunchStrategiesContext = React.createContext<{
  launchStrategies: GameLaunchStrategies;
  callbackMode: CallbackMode;
}>({ launchStrategies: {}, callbackMode: 'event' });

interface LaunchStrategiesProviderPropTypes {
  children?: React.ReactNode;
  launchStrategies: GameLaunchStrategies;
  visible?: boolean;
  deviceType: DeviceType;
  loggedIn: boolean;
}

const getCallbackMode = (
  breakpoint: string,
  deviceType: string,
  loggedIn: boolean
): CallbackMode =>
  !isIframeWrapperEnabled() &&
  (!loggedIn ||
    (breakpoint === SCREEN_BREAKPOINT_NAMES.large && deviceType === 'desktop'))
    ? 'event'
    : 'native';

export const LaunchStrategiesProvider: React.FC<LaunchStrategiesProviderPropTypes> = ({
  children,
  visible = true,
  launchStrategies,
  deviceType,
  loggedIn,
}) => {
  const { breakpoint } = useWindowBreakpoint();
  if (!visible) return null;
  const callbackMode = getCallbackMode(breakpoint, deviceType, loggedIn);
  return (
    <LaunchStrategiesContext.Provider
      value={{ launchStrategies, callbackMode }}
    >
      {children}
    </LaunchStrategiesContext.Provider>
  );
};
